import React, { Component } from 'react';
import Collapse, { Panel } from 'rc-collapse';

import './OrderSummaryItems.scss';
import { ReadonlyItemList } from 'components';
import { SofaButton } from '@sofology/sofologycomponents';

interface OwnProps {
    useOrderEntries?: boolean;
}

interface OwnPropsWithDefault {
    opened: boolean;
}

interface OwnState {
    opened: boolean;
}

class OrderSummaryItems extends Component<OwnProps & OwnPropsWithDefault, OwnState> {
    static defaultProps: Partial<OwnPropsWithDefault> = {
        opened: false
    };

    state = {
        opened: this.props.opened
    };

    private linkElement = React.createRef<HTMLSpanElement>();
    private collapseRef = React.createRef<HTMLDivElement>();

    // Accessibility fix for GT-478
    // Make collapse-header impossible to focus with TAB via keyboard, so focus goes directly to the button
    componentDidMount() {
        const header = this.collapseRef.current?.querySelector('.rc-collapse-header');
        if (header) {
            header.removeAttribute('tabindex');
        }
    }

    render(): JSX.Element {
        const { opened } = this.state;
        const { useOrderEntries } = this.props;
        const arrowIcon = <i className={opened ? 'sa sa-angle-up' : 'sa sa-angle-down'}></i>;
        const showHideItemsButtonText = <>{opened ? 'Hide' : 'View'} items {arrowIcon}</>;

        return (
            <div className='order-summary-items' ref={this.collapseRef}>
                <Collapse accordion={true} activeKey={this.state.opened ? ['0'] : []}>
                    <Panel
                        key='0'
                        header={
                            <div className='order-summary-items__header'>
                                <span className='order-summary-items__header__title'>
                                    <i className='sa sa-trolley'></i>
                                    Order summary
                                </span>
                                <span className='order-summary-items__header__trigger' ref={this.linkElement}>
                                    <SofaButton
                                        text={showHideItemsButtonText}
                                        variant='small'
                                        // Accessibility fix for GT-478
                                        // Make button control the state to avoid double toggle via keyboard's "Enter"
                                        onClick={() => {
                                            this.setState(state => ({ opened: !state.opened }));
                                        }}
                                    />
                                </span>
                            </div>
                        }
                        showArrow={false}
                    >
                        <ReadonlyItemList useOrderEntries={useOrderEntries} />
                    </Panel>
                </Collapse>
            </div>
        );
    }
}

export default OrderSummaryItems;